import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/get-started')({
  head,
  staticData: {
    title: 'Get Started',
  },
  component: lazyRouteComponent(() => import('./get-started.component'), 'GetStartedComponent'),
  pendingComponent: lazyRouteComponent(() => import('./get-started.component'), 'GetStartedPendingComponent'),
});
